import Main from '../components/layout/Main';
import Glossary from '../containers/Glossary/Glossary';
import React from 'react';

export const GlossaryPage = () => {
    return <div>
        <Main title="Glossary" pageClassName="clipped-page">
            <Glossary/>
        </Main>
    </div>
}